import { motion } from 'framer-motion';

export const HoverLiftAnimation = ({ children }) => (
    <motion.div
      whileHover={{ y: -3 }}
      whileTap={{ scale: 0.95 }}
      transition={{ duration: 0.2 }}
    >
      {children}
    </motion.div>
  );
  
  export const ScaleAnimation = ({ children }) => (
    <motion.div
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      transition={{ duration: 0.2 }}
    >
      {children}
    </motion.div>
  );